//import { useAppContext } from '@hooks/use-app-context'
import { analyticsCurrentAction } from '@store/atoms'
import { useAtom, useSetAtom } from 'jotai'
import { useEffect, useState } from 'react'
//import { Steps } from '@store/reducer'
import { useMobileContext } from '@hooks/use-mobile-context'
//import type { AnalyticsAction } from './analytics.component'
//import { activedStep, activedSubStep } from '@store/store'
//import { StepsSimulatore } from '@store/stepsSimulatore'

export function useAnalytics() {
	//const [activeStep] = useAtom(activedStep)
	//const [activeSubStep] = useAtom(activedSubStep)
	const { state: mobileState } = useMobileContext()
	const setCurrentAnalyticsAction = useSetAtom(analyticsCurrentAction)

	/* useEffect(() => {
		switch (activeStep) {
		
			case 2:
				setCurrentAnalyticsAction('Step20' as AnalyticsAction)
				break

			case 3:
				setCurrentAnalyticsAction('Step30' as AnalyticsAction)
				break

			case 4:
				setCurrentAnalyticsAction('Step40' as AnalyticsAction)
				break

			case 5:
				setCurrentAnalyticsAction('Step50' as AnalyticsAction)
				break

			default:
				break
		}
	}, [activeStep, activeSubStep, setCurrentAnalyticsAction]) */

	useEffect(() => {
		if (mobileState.isSessionActive) {
			setCurrentAnalyticsAction('StepChangeToTablet')
		}
	}, [mobileState.isSessionActive, setCurrentAnalyticsAction])
}